module.exports = __webpack_public_path__ + "static/media/комплимент.58661dcb.jpg";